import React, {useContext} from "react";
import {useTranslation} from "react-i18next";
import {RegionSelectedContext} from "../../contexts/RegionSelectedContext";
import classNames from "classnames";
import styled from "styled-components";
import '../../components/homeComponents/HomeStyles.css'

const Region = styled.span`
  font-family: AvenirNextLTPro-Regular;
  text-transform: uppercase;
  cursor: pointer;

  &.selected {
    font-family: AvenirNextLTPro-Bold
  }
`;

const RegionSelectorComponent: React.FC<{customStyle?: object}> = ({customStyle}) => {
    const {t} = useTranslation();

    // @ts-ignore
    const {regionSelected, setRegionSelected} = useContext(RegionSelectedContext);

    return (
        <div className={'headerRegionSelector'} style={{...customStyle}}>
            <Region
                onClick={() => setRegionSelected("eu")}
                className={classNames({'selected': regionSelected === "eu"})}
            >
                {t('home.europe')}
            </Region>
            <span className='regionSeparator'>|</span>
            <Region
                onClick={() => setRegionSelected("latam")}
                className={classNames({'selected': regionSelected === "latam"})}
            >
                {t('home.latam')}
            </Region>
            <span className='regionSeparator'>|</span>
            <Region
                onClick={() => setRegionSelected("reaseguro")}
                className={classNames({'selected': regionSelected === "reaseguro"})}
            >
                {t('home.reaseguro')}
            </Region>
        </div>
    );
};

export default RegionSelectorComponent;
